import script from "./SwiftDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./SwiftDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./SwiftDatePicker.vue?vue&type=style&index=0&id=272fcfdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-272fcfdf"]])

export default __exports__